export default __webpack_public_path__ + "static/media/1.fafd41de.jpg";